export class ProvidersType
{
	static SLIDER: string = 'slider';
	static POPUP: string = 'popup';
}
